<div class="ui basic narrow segment" [class.loading]="isLoading">
    <app-header title="{{ 'settings.performance-notifications.header' | translate }}" [back]="true"></app-header>

    <div class="ui segment" *ngFor="let resource of resources">
        <app-segment-header
            [title]="resourceTags[resource] | appTranslate"
            [collapsible]="true"
            [collapsed]="true"
        ></app-segment-header>

        <div class="content">
            <ng-template ngFor let-entity [ngForOf]="entities">
                <div *ngIf="sortedSettings.has(resource + '.' + entity)">
                    <h4 class="ui header">{{ entityTags[entity] | appTranslate }}</h4>
                    <div class="ui divider"></div>

                    <div class="settings-container">
                        <app-company-setting
                            *ngFor="let setting of sortedSettings.get(resource + '.' + entity)"
                            [companySetting]="setting"
                            (toggled)="changeSetting($event)"
                        >
                        </app-company-setting>
                    </div>
                </div>
            </ng-template>
        </div>
        <div class="ui hidden clear divider"></div>
    </div>
</div>
